<template>
	<div ref="zoneRef">
		<div v-if="scoringEnabled && points > 0" class="points-statement-zone">
			<PointsClaimButton :promo-id="promoId" :delivery-location-id="deliveryLocationId" :promo-name="promoName" :points="points" :overlay-target="overlayTarget" />
		</div>
	</div>
</template>

<script setup>
import { ref, inject, onMounted, onBeforeUnmount } from 'vue';
import PointsClaimButton from './PointsClaimButton.vue';
import { calculatePoints, isScoringMatrixAvailable } from '@/services/pointsMatrixService';

const zoneRef = ref(null);
const overlayTarget = inject('overlayTarget', null);

const promoId = ref('');
const deliveryLocationId = ref(null);
const promoName = ref('');
const scoringEnabled = ref(false);
const points = ref(0);
let _mountTarget = null;

function handleContext(event) {
	const { promoId: pid, deliveryLocationId: dlId, scoringEnabled: scoring, promoData } = event.detail;
	promoId.value = pid?.toString() ?? '';
	deliveryLocationId.value = dlId ?? null;
	promoName.value = promoData?.promoName ?? '';
	scoringEnabled.value = !!scoring && isScoringMatrixAvailable();
	points.value = scoringEnabled.value ? calculatePoints(promoData ?? {}) : 0;
}

onMounted(() => {
	_mountTarget = zoneRef.value?.parentElement;
	_mountTarget?.addEventListener('vue:points-context', handleContext);

	if (_mountTarget?._pendingPointsContext) {
		handleContext({ detail: _mountTarget._pendingPointsContext });
	}
});

onBeforeUnmount(() => {
	_mountTarget?.removeEventListener('vue:points-context', handleContext);
	_mountTarget = null;
});
</script>
